import DocumentCompareContent from '@/components/compare/document-compare/document-compare';

export default function DocumentCompare() {
    return <DocumentCompareContent />;
}
